

import { controls } from "../../controls";


const installment = {
  label: "installment Details",
  pageLabel: "installment Details",
  starting: true,
  url: "installment",
  pageType: "history",
  formState: { checked: "view" },
  formActions: { edit: { allow: true }, delete: { allow: true } },
  // "Address.",
  form: [

    ...controls.displayText({label:"As On Date/Opening Date",width:"col-sm-2",star:true}),
    ...controls.datePicker({name:"as_on_date",isRequired:true,defaultValue:"sessiondate",width:"col-sm-2"}),
    ...controls.displayText({ label: "For Amount", width: "col-sm-2" ,star:true}),
    ...controls.numberOnly({ placeHolder: "For Amount",isRequired:true,name: "installment_amount", width: "col-sm-2" }),     
    ...controls.displayText({  width: "col-sm-2", label:"Installment Frequency" }),
    ...controls.select({name: "interest_freq", width: "col-sm-2",options: [
        {
          label: "Monthly",
          value: "Monthly"
        },
        {
          label: "Quartrly",
          value: "Quartrly"
        },
        {
          label: "Half Yearly",
          value: "HalfYearly"
        },
        {
          label: "Yearly",
          value: "Yearly"
        },
        {
          label: "Maturity Time",
          value: "MaturityTime"
        }
      ]}),
  
    ...controls.displayText({ label: "Interest Rate", width: "col-sm-2" }),
    ...controls.showData({width: "col-sm-2",name:"ints_rate",data: "ints_rate" }),
    ...controls.displayText({tab:"recurringdeposit",label: "No Of Installment",width:"col-sm-2"}),

    ...controls.numberofinstallment({ tab: "recurringdeposit" }),
    
    ...controls.displayText({ label: "Moratorium Period", width: "col-sm-2" }),
    ...controls.numberOnly({placeHolder: "Moratorium Period",name:"moratorium_period",width:"col-sm-2"}),
    ...controls.displayText({ label: "First Installment Date", width: "col-sm-2" }),
   ...controls.datePicker({name:"first_installment_date",width:"col-sm-2"}),
   

    ...controls.button({
        label: "ADD", onclick: {
          action: "appendToHTMLTable",
          tableNameField: 'installmentloan_table',
          requiredField: ["customer_number", "type","member_no","customer_fullname_display","date_added","isActive"]
        }, width: "col-sm-2"
      }),
      {
        inputType: "table",
        tableTitle: "",
        // convertedTo: "nominee_table",
        deletable: true,
        // editable: true,
        // addRows: true,
        tableHeaders: [
          { label: "Sr", type: "autoinc" },
          { label: "CIN", field: "customer_number"},
          { label: "Type", field: "type"},
          { label: "Member No", field: "member_no" },
          { label: "Name", field: "customer_fullname_display"},    
          { label: "Date Added", field: "date_added",displaytype: 'date' },
          { label: "Active", field: "isActive" },
        ],
        widths: {
          parent: "col-sm-12",
          children: "col-sm-12"
        },
        name: "installmentloan_table"
      },
      ...controls.displayText({ label: "Address", width: "col-sm-2" }),
      ...controls.showData({name:"address",data:"address",width:"col-sm-4"})

   
  ]
}

export default installment;